import { Component, Input } from '@angular/core';
import {
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './hawaii-model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  AdditionalOptions,
  CoverageLimit,
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-hawaii',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './hawaii.component.html',
  styleUrl: './hawaii.component.scss',
})
export class HawaiiComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('hawaii', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('hawaii', null);
    }
  }

  AdditionalOptions = AdditionalOptions;
  PersonalInjuryProtectionSelection = PersonalInjuryProtectionSelection;
  CoverageLimit = CoverageLimit;
 
}
